import React from 'react';
import { Row, Col } from 'react-bootstrap';
import SEO from '../components/seo';
import Article from '../components/article';
import Layout from '../layouts/default-layout';
import useSiteMetadata from '../hooks/use-site-metadata';
var BrandHeartPage = function BrandHeartPage(_ref) {
    var location = _ref.location;
    var _useSiteMetadata = useSiteMetadata(), siteURL = _useSiteMetadata.siteURL;
    var canonicalUrl = "" + siteURL + location.pathname;
    var pageTitle = 'Brand Heart';
    var articles = [
        {
            articleTitle: 'Who we are',
            articleContent: /*#__PURE__*/ React.createElement("p", {
                className: "display-3 text-center mb-0"
            }, "We are an evidence-based wellness company who believes self-care is a necessary pillar to health.")
        }, {
            articleTitle: 'Purpose',
            articleContent: /*#__PURE__*/ React.createElement("p", {
                className: "display-3 text-center mb-0"
            }, "Help people build rituals to put themselves first.")
        },
        {
            articleTitle: 'What we offer',
            articleContent: /*#__PURE__*/ React.createElement("p", {
                className: "display-4 text-center line-height-large mb-0"
            }, "We're an online self-care marketplace for evidence-based, carefully curated wellness products & mission-driven brands. We provide support for the unknowns of every phase of life.")
        },
        {
            articleTitle: 'Our Vision',
            articleContent: /*#__PURE__*/ React.createElement("p", {
                className: "display-3 text-center mb-0"
            }, "A world where self-care is foundational to health.")
        },
        {
            articleTitle: 'Our Mission',
            articleContent: /*#__PURE__*/ React.createElement("p", {
                className: "display-4 line-height-large text-center mb-0"
            }, "To help people be active agents in their healthcare and build a practice of self-care with the right tools at the right time of their life.")
        },
        {
            articleTitle: 'Core Values',
            articleContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Row, {
                className: "justify-content-between"
            }, /*#__PURE__*/ React.createElement(Col, {
                md: 6,
                className: "mb-5"
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "h5 font-weight-bolder mb-3"
            }, "Trustworthy"), /*#__PURE__*/ React.createElement("p", {
                className: "large mb-0"
            }, "We vet our products and make your self-care simple.")), /*#__PURE__*/ React.createElement(Col, {
                md: 6,
                className: "mb-5"
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "h5 font-weight-bolder mb-3"
            }, "Support"), /*#__PURE__*/ React.createElement("p", {
                className: "large mb-0"
            }, "We support you in supporting yourself."))), /*#__PURE__*/ React.createElement(Row, {
                className: "justify-content-between"
            }, /*#__PURE__*/ React.createElement(Col, {
                md: 6,
                className: "mb-5 mb-md-0"
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "h5 font-weight-bolder mb-3"
            }, "Balance"), /*#__PURE__*/ React.createElement("p", {
                className: "large mb-0"
            }, "Self-care is about helping you build a practice and a balance of your own care with the other things you care about. We\u2019ll meet you wherever you are.")), /*#__PURE__*/ React.createElement(Col, {
                md: 6
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "h5 font-weight-bolder mb-3"
            }, "Representation"), /*#__PURE__*/ React.createElement("p", {
                className: "large mb-0"
            }, "Our uniquely holistic approach to healthcare, wellness and beauty is rooted in making self-care as inclusive and equitable as possible."))))
        },
        {
            articleTitle: 'Audience',
            articleContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h3", {
                className: "h5 font-weight-bolder mb-4"
            }, "\u201CDo it All\u201D Self-Care Seekers", ' '), /*#__PURE__*/ React.createElement("span", {
                className: "display-4 text-serif line-height-large"
            }, /*#__PURE__*/ React.createElement("p", null, "Modern boss women between the ages of 25 - 65, who are health-conscious and self-care curious. They care about making a good impression and are willing to spend on luxury items that meet their needs. They are time-starved, driven by their schedules and juggling life demands."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0"
            }, "Because they're often too overwhelmed to do the necessary research, they often end up neglecting their self-care and feeling isolated. While they help manage others\u2019 self-care over their own, they are ever more mindfully trying to manage anxiety in an effort to find personal fulfillment. Regardless of their life stage, they need trusted and tried self-care delivered to them.")))
        }
    ];
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: pageTitle
    }), articles.map(function (item, index) {
        var itemKey = "article-" + index;
        return /*#__PURE__*/ React.createElement(Article, {
            title: item.articleTitle,
            key: itemKey,
            pageUrl: canonicalUrl
        }, item.articleContent);
    }));
};
export default BrandHeartPage;
